<script setup lang="ts">
import { ref } from "vue";
import {
  OrderStatus,
  cancelOrder as cancelOrderApi,
  activateOrder as activateOrderApi,
} from "#/../js/api/order";

const props = defineProps<{
  orderId: string;
  status: OrderStatus,
}>();

const loading = ref(false);
const status = ref<OrderStatus>(props.status);

const handleActivate = async () => {
  if (loading.value) return;

  loading.value = true;

  try {
    await activateOrderApi(props.orderId);
    status.value = "activated";
  } catch (e) {
    console.error(e);
  } finally {
    loading.value = false;
  }
};

const handleCancel = async () => {
  if (loading.value) return;

  loading.value = true;

  try {
    await cancelOrderApi(props.orderId);
    status.value = "cancelled";
  } catch (e) {
    console.error(e);
  } finally {
    loading.value = false;
  }
};
</script>

<template>
  <div class="order-actions__buttons">
    <button v-if="status === 'activated'" class="btn tag-disable" disabled>
      Активирован
    </button>

    <button v-else-if="status === 'cancelled'" class="btn tag-disable" disabled>
      Отменён
    </button>

    <button v-else-if="status === 'new'" class="btn tag-disable" disabled>
      Ожидает активации
    </button>

    <template v-else-if="status === 'paid'">
      <button
        class="btn btn-primary"
        :disabled="loading"
        @click="handleActivate"
      >
        Активировать
      </button>

      <button
        class="btn btn-link mt-16"
        :disabled="loading"
        @click.prevent="handleCancel"
      >
        Отменить заказ
      </button>
    </template>
  </div>
</template>

<style scoped lang="scss">
.order-actions {
  &__buttons {
    button {
      justify-content: center;
      width: 100%;
      color: var(--white-color);
    }

    button.btn-link {
      background: none;
      border: none;
      color: var(--link-color);
      cursor: pointer;
    }

    button:disabled {
      opacity: 0.6;
      cursor: not-allowed;
    }
  }
}
</style>
